import React from 'react';
import { InformationPanel, TextParagraph } from '../../common/informationPanel/InformationPanel';
import { DecommissionASiteResultScreenType, DecommissionASiteResultStatus } from '../../../context/DecommissionASiteContext';

export const DecommissionASiteResultScreen = ({ decommissionSiteResult }: DecommissionASiteResultScreenType) => {
  const DecommissionResultSuccessPanelText: TextParagraph[] = [
    {
      text: 'Decommission Successful',
      lineBreak: false,
    },
  ];

  const DecommissionResultFailPanelText: TextParagraph[] = [
    {
      text: 'Decommission unsuccessful',
      lineBreak: true,
    },
    {
      text: 'Please do not remove devices.',
      lineBreak: true,
    },
  ];

  function getPanelText() {
    if (decommissionSiteResult.status === DecommissionASiteResultStatus.SUCCESS) {
      return DecommissionResultSuccessPanelText;
    }
    return DecommissionResultFailPanelText;
  }

  return (
    <>
      {/* TODO add loading spinner here */}
      <InformationPanel
        title={null}
        textArray={getPanelText()}
        background={false}
        textAlign={'center'}
        dataTestId={'info-panel-loading'}
      />
    </>
  );
};
